{
  "filters": {
    "creationDate": {
      "label": "Datum des Hochladens",
      "formatter": {
        "input": "YYYY-MM-DD",
        "tag": "YYYY-MM-DD"
      },
      "periodSeparator": "bis",
      "placeholder": "Einen Zeitraum auswählen"
    },
    "searchByNameOrVersion": "Nach Name oder Version suchen",
    "range": "Gerätetypen",
    "status": "Status"
  },
  "newFirmware": "Neue Firmware hinzufügen",
  "noFirmware": "Keine Firmware verfügbar",
  "column": {
    "versionName": "Versionsname",
    "type": "Typ",
    "declination": "Modell",
    "version": "Version",
    "buildDate": "Build-Datum",
    "creationDate": "Datum des Hochladens",
    "dateFormat": "YYYY-MM-DD [um] hh:mm A",
    "status": "Status"
  },
  "actions": {
    "activate": {
      "label": "Die Firmware aktivieren",
      "description": "Die Firmware {name} wird aktiviert."
    },
    "deactivate": {
      "label": "Die Firmware deaktivieren",
      "description": "Die Firmware {name} wird deaktiviert."
    },
    "delete": {
      "label": "Die Firmware löschen",
      "description": "Die Firmware {name} wird gelöscht.",
      "descriptionEmbedded": "Die Firmware {name} wird derzeit von einer Kampagne oder einem Einzelvorgang verwendet. Ihre Löschung wirkt sich auf die Vorgänge aus."
    }
  },
  "status": {
    "ACTIVATED": "Aktiv",
    "DEACTIVATED": "Inaktiv"
  },
  "section": {
    "informations": {
      "title": "Firmware-Informationen"
    },
    "compatibility": {
      "title": "Firmware-Kompatibilität"
    },
    "complements": {
      "title": "Ergänzungen"
    }
  },
  "validation": {
    "name": "Firmware-Name ist erforderlich",
    "version": "Firmware-Version ist erforderlich"
  },
  "form": {
    "name": "Versionsname",
    "description": "Beschreibung",
    "version": "Version",
    "range": "Bereich",
    "declination": "Modell",
    "hardwareVersions": "Hardware-Versionen",
    "firmwareVersions": "Firmware-Versionen",
    "status": "Status",
    "minimalCompatibleFirmwareVersion": "Minimale kompatible Firmware-Version"
  },
  "upload": {
    "title": "Eine Datei auswählen",
    "browse": "Durchsuchen",
    "restrictionInformation": "Die Firmware muss eine ZIP-Datei sein und darf nicht größer als 750 MB sein.",
    "validation": {
      "fileMandatory": "Die Datei muss im ZIP-Format vorliegen.",
      "fileEmpty": "Die ZIP-Datei darf nicht leer sein.",
      "fileSize": "Die ZIP-Datei darf nicht größer als 750 MB sein."
    }
  },
  "firmwareInfo": {
    "compatibility": {
      "title": "Kompatibilität",
      "description": "Die ausgewählte Firmware hat die folgenden Abhängigkeiten:"
    },
    "equipmentTypeAttached": "Gerätetyp, der der Firmware zugeordnet ist",
    "compatibleHardwareVersions": "Kompatible Hardware-Versionen",
    "compatibleFirmwareVersions": "Kompatible Firmware-Versionen"
  },
  "selected": "Ausgewählte Firmware:"
}
